const LIGHTBOX_FORMAT_COUNT = 2;

const splitImageUrls = (originalImageUrls?: string[]) => {
  const [metaImageUrl, ...headerImageUrls] = originalImageUrls ?? [];
  const imageUrls = headerImageUrls.slice(0, -LIGHTBOX_FORMAT_COUNT);
  const lightboxImageUrls = headerImageUrls.slice(-LIGHTBOX_FORMAT_COUNT);

  return {
    metaImageUrl,
    imageUrls,
    lightboxImageUrls,
  };
};

export default splitImageUrls;
